<template>
<div class="chapter">
<div class="inner_page">
<p class="noindentv1"><a id="page_iv"></a>Also by Jack Womack</p>
<p class="noindentv1"><em>Ambient</em></p>
<p class="noindentv"><em>Terraplane</em></p>
<p class="noindentv"><em>Heathern</em></p>
<p class="noindentv"><em>Elvissey</em></p>
<p class="noindentv"><em>Random Acts of Senseless Violence</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// otherfm01.vue?0cb51e8b